// extracted by mini-css-extract-plugin
export default {"tips":"TipsCard_tips__4u7s+"};